const PriceTypeConfig = {
  collection: "price_types",
  fields: ["id", "name", "locale.label", "locale.display_style.id"],

  filter: "filter[status][_eq]=active",

  adapter: class PriceType {
    constructor(price_type) {
      this.id = price_type.id;
      this.name = price_type.name;

      let locale = price_type.locale?.[0];

      this.label = locale?.label;
      this.display_style = locale?.display_style?.id;
    }

    map(collections, maps) {
      this.display_style =
        maps.attribute_styles?.[this.display_style] ||
        maps.specification_styles?.[this.display_style];
    }
  }
};

export default PriceTypeConfig;
